import { isTouchDevice } from "@myvp/shared/src/functions/is-touch-device"
import { isAndroid } from "@myvp/shared/src/functions/is-android"
import { isSafari } from "@myvp/shared/src/functions/is-safari"

export function isIos() {
  return isTouchDevice() && !isAndroid() && isSafari()
}
